import { Box, Button, Dialog, DialogContent } from "@mui/material";
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import { useIdleModal } from "../hooks/useIdleModal/useIdleModal";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useIdleModalStyles } from "./styles";

type Props = {
  open: boolean;
  continueSession: () => void;
};

export const IdleModal = ({ open, continueSession }: Props) => {
  const classes = useIdleModalStyles();
  const { startTimer, secondsLeft, clearTimer } = useIdleModal();
  const { t } = useTranslation('common');

  useEffect(() => {
    if (open) {
      startTimer();
    }
  }, [open]);

  const onContinueClick = () => {
    clearTimer();
    continueSession();
  }

  return (
    <Dialog open={open} fullWidth maxWidth={'xs'} data-testid="idle-modal">
      <DialogContent sx={classes.container}>
        <div>
          <AccessAlarmIcon sx={classes.icon} />
        </div>
        <Box sx={classes.title}>{t('common.timeoutModal.deviceTimeout')}</Box>
        <Box sx={classes.subtitle}>
          {t('common.timeoutModal.deviceTimeoutMessage', { secondsLeft })}
        </Box>

        <Box sx={classes.buttonContainer}>
          <Button onClick={onContinueClick} color={'primary'} variant={'contained'}>{t('common.timeoutModal.continueSession')}</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
